export const localStorageKey = {
    language: '_qcells_language_',
    notice: '_qcells_notice_',
    loginFailed: '_qcells_login_failed_',
};
